import React from 'react';
import CommentInlineError from './CommentInlineError';
import CommentEditor, { CommentEditorSubmitLabel } from './CommentEditor';

interface CommentsSidebarEditorProps {
  error?: string;
  text: string;
  onChange: (value: string) => void;
  onSubmit: (value: string) => Promise<void>;
}

const CommentsSidebarEditor = (props: CommentsSidebarEditorProps) => {
  const { error, text, onChange, onSubmit } = props;
  return (
    <div
      style={{
        display: 'flex',
        padding: '16px 12px',
        flexDirection: 'column',
        gap: 10,
      }}
    >
      {error && (
        <CommentInlineError
          error={error}
          type={CommentEditorSubmitLabel.Send}
        />
      )}
      <CommentEditor
        text={text}
        submitButtonLabel={CommentEditorSubmitLabel.Send}
        placeholder="Leave a comment"
        onChange={onChange}
        onSubmit={onSubmit}
      />
    </div>
  );
};

export default CommentsSidebarEditor;
